/* Component Dependencies */
var travelByInterestTemplate = require('templates/travelByInterest.hbs');
var AriesComponent = require('libs/aries-component');
var $ = require('jquery');

AriesComponent.create({
  type: 'travelByInterest',
  template: {
    'travelByInterest': travelByInterestTemplate
  },
  events: {
    'click .details-panel-container': 'togglePanel',
    'click .description-info': 'triggerAnchorClick'
  },
  togglePanel: function(event) {
    if(event.target.nodeName !== "A") {
      var $currentElement = $(event.target).closest('.details-panel-container').find('.details-panel'),
      isExpanded = $currentElement.hasClass('expanded-panel');
    
      this.$el.find('.details-panel').removeClass('expanded-panel');
      if(!isExpanded)
        $currentElement.addClass('expanded-panel');
    }
  },
  triggerAnchorClick: function(event){
    event.preventDefault();
    event.stopPropagation();
    $(event.target).parents('.img-container').find('a.img-inner-wrapper')[0].click();
   }
});
